import { useState } from 'react';
import clsx from 'clsx';
import PreconfiguredMessages from '../PreConfiguredMessages';
import ConversationHistory from './ConversationHistory';
import styles from './MessagingAdmin.module.scss';

const CONVERSATION_HISTORY = 'conversation_history';
const PRECONFIGURED_MESSAGES = 'preconfigured_messages';

const TABS = [
  { id: CONVERSATION_HISTORY, label: 'Conversation History' },
  { id: PRECONFIGURED_MESSAGES, label: 'Preconfigured Messages' },
];

const MessagingAdmin = () => {
  const [activeTab, setActiveTab] = useState(TABS[0].id);

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1 className={styles.title}>Messaging</h1>
      </div>
      <div className={styles.tabList} role="tablist">
        {TABS.map(tab => (
          <button
            key={tab.id}
            role="tab"
            aria-selected={activeTab === tab.id}
            className={clsx(styles.tab, activeTab === tab.id && styles.active)}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div className={styles.tabContent} role="tabpanel">
        {activeTab === PRECONFIGURED_MESSAGES && <PreconfiguredMessages />}
        {activeTab === CONVERSATION_HISTORY && <ConversationHistory />}
      </div>
    </div>
  );
};

export default MessagingAdmin;
